<template>
    <div class="sms-responses">

        <!-- Título da página -->
        <mu-title color="secondary" textStrong="700">Respostas</mu-title>

        <!-- Breadcrumbs -->
        <mu-breadcrumbs divider="—">
            <font-awesome-icon icon="chevron-right" slot="divider" class="icon-sm icon-margin-right"/>
            <mu-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :to="{ name: item.route }" :disabled="item.disabled">{{ item.text }}</mu-breadcrumbs-item>
        </mu-breadcrumbs>

        <br>

        <!-- Lista -->
        <div class="responses" v-if="!responses.loading">
            <mu-paper :z-depth="1">

                <!-- Listagem dos responses tablet/desktop -->
                <mu-data-table :columns="responses.columns" :data="responses.list" @row-click="dialogResponse" v-if="viewport !== 'mobile'" class="mu-table-custom">
                    <template slot="empty">
                        <div class="box-table-empty">
                            Não foi encontrado registros de respostas
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <td>{{ dateFormat(scope.row.receive_ts, true) }}</td>
                        <td>{{ scope.row.rec_msg }}</td>
                        <td>{{ scope.row.name }}</td>
                        <td>{{ scope.row.phone }}</td>
                        <td>
                            <div class="status answered" v-if="scope.row.isReplied">
                                <mu-dot color="green"></mu-dot> Mensagem respondida
                            </div>
                            <div class="status not-answered"  v-else>
                                <mu-dot color="red"></mu-dot> Mensagem não respondida
                            </div>
                        </td>
                    </template>
                </mu-data-table>

                <!-- Listagem de responses mobile -->
                <mu-list textline="two-line" v-if="viewport === 'mobile'">
                    <span v-for="(item, key) in responses.list" :key="key" @click="dialogResponse(null, item, null)">
                        <mu-list-item button>
                            <mu-list-item-content>
                                <mu-list-item-title>{{ item.rec_msg }}</mu-list-item-title>
                                <mu-list-item-sub-title>
                                    {{ item.phone }} / {{ item.name }}
                                    <div class="status answered" >
                                        <mu-dot color="green"></mu-dot> Mensagem respondida
                                    </div>
                                    <div class="status not-answered"  >
                                        <mu-dot color="red"></mu-dot> Mensagem não respondida
                                    </div>
                                </mu-list-item-sub-title>
                            </mu-list-item-content>
                            <mu-list-item-action>
                                <font-awesome-icon icon="search" class="icon-md"/>
                            </mu-list-item-action>
                        </mu-list-item>
                        <mu-divider></mu-divider>
                    </span>
                </mu-list>
            </mu-paper>

            <!-- Paginação -->
            <mu-flex class="paginate" justify-content="center" v-if="responses.paging.total > responses.paging.size">
                <mu-pagination :total="responses.paging.total" :page-count="5" :page-size="responses.paging.size" :current.sync="responses.paging.page" @change="load()"></mu-pagination>
            </mu-flex>
        </div>

        <!-- Loading -->
        <mu-loading text="Carregando a lista de respostas" v-if="responses.loading"></mu-loading>

        <!-- Dialogo -->
        <mu-dialog title="Responder mensagem" width="450" :open.sync="dialog.visible">
            <div class="dialog-response" v-if="dialog.data">
                <div class="phone">
                    <mu-flex align-items="center">
                        <font-awesome-icon icon="mobile-alt" size="2x" />
                        {{ dialog.data.phone }}
                    </mu-flex>
                </div>
                <div v-if="dialog.data.campaign" class="campaign">
                    <label><strong>Campanha:</strong> {{ dialog.data.campaign.title }}</label>
                    <p><strong>Mensagem:</strong> {{ dialog.data.campaign.message }}</p>
                </div>
                <div class="date">
                    <strong>Resposta recebida em {{ dateFormat(dialog.data.receive_ts, true) }}</strong>
                </div>
                <div class="message">
                    {{ dialog.data.rec_msg }}
                </div>
                <mu-text-field v-model="dialog.form.message" multi-line :rows="4" color="#999999" full-width :help-text="`Você já digitou ${dialog.form.message.length} caracteres`" label="Digite sua resposta" v-on:keyup="messageSlug" @change="messageSlug"></mu-text-field>
                <div class="status answered" v-if="dialog.data.isReplied">
                    <mu-dot color="green"></mu-dot> Mensagem respondida
                </div>
                <div class="status not-answered" v-else>
                    <mu-dot color="red"></mu-dot> Mensagem não respondida
                </div>
                <mu-flex>
                    <mu-button round color="primary" class="button-save" @click="saveForm()" :disabled="!dialog.form.message">
                        <font-awesome-icon icon="check" class="icon-md"/>
                        Enviar
                    </mu-button>
                    <mu-button round @click="dialog.visible = false">Cancelar</mu-button>
                </mu-flex>
                <div class="blacklist" v-if="dialog.contact.data">
                    <mu-flex align-items="center" justify-content="between">
                        <div>
                            <strong>Deseja <span>{{ dialog.contact.data.blacklist ? 'remover' : 'adicionar' }}</span> {{ dialog.contact.data.blacklist ? 'da' : 'a' }} lista de contatos bloqueados?</strong>
                            <p>{{ dialog.contact.data.firstname }} {{ dialog.contact.data.lastname }} ({{ dialog.contact.data.phone }})</p>
                        </div>
                        <mu-switch v-model="dialog.contact.data.blacklist" color="#000000" @change="blackList(dialog.contact.data.id, dialog.contact.data.blacklist)"></mu-switch>
                    </mu-flex>
                </div>
                <div class="blacklist" v-else>
                    <mu-flex align-items="center" justify-content="between">
                        <div>
                            <strong>Deseja <span>adicionar</span> a lista contatos bloqueados?</strong>
                            <p>{{ dialog.data.phone }}</p>
                        </div>
                        <mu-switch color="#000000" @change="blackListNew(dialog.data.phone)"></mu-switch>
                    </mu-flex>
                </div>
            </div>
        </mu-dialog>

    </div>
</template>

<script>
    import ResponsesServices from '@/services/services/responses'
    import BlacklistServices from '@/services/contacts/blacklist'

    export default {
        name: 'app-reports-dashboard',

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                breadcrumbs: [
                    {
                        text: 'Serviços',
                        route: 'app.services',
                        disabled: false
                    },
                    {
                        text: 'Respostas',
                        disabled: true
                    }
                ],
                responses: {
                    loading: false,
                    paging: {
                        page: 1,
                        size: 10,
                        total: 0
                    },
                    columns: [
                        { title: 'Data', name: 'created_at', width: 160 },
                        { title: 'Mensagem', name: 'message' },
                        { title: 'Nome', name: 'name' },
                        { title: 'Telefone', name: 'phone' },
                        { title: 'Status', name: 'status' }
                    ],
                    list: []
                },
                dialog: {
                    visible: false,
                    data: {},
                    contact: {
                        data: {},
                        loading: false
                    },
                    form: {
                        msgReponse_Id: 0,
                        message: ''
                    }
                }
            }
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {

            /**
             * Utilizado para verificar se o acesso é de desktop, table ou mobile
             */
            viewport () {
                return this.$currentViewport.label
            }
        },

        // ╔═╗╦═╗╔═╗╔═╗╔╦╗╔═╗╔╦╗
        // ║  ╠╦╝║╣ ╠═╣ ║ ║╣  ║║
        // ╚═╝╩╚═╚═╝╩ ╩ ╩ ╚═╝═╩╝

        /**
         * Acessamos o load para carregar a lista de contato assim que
         * o componente é montado
         */
        async created () {
            await this.load()
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            /**
             * Carrega as respostas
             */
            async load () {
                try {
                    this.$eventHub.$emit('loading', true, 'Carregando as respostas.')

                    let result = await ResponsesServices.findAll({
                        page: this.responses.paging.page
                    })

                    if (result && result.status) {
                        this.responses.list = result.results
                        this.responses.paging.page = result.currentPage
                        this.responses.paging.total = result.rowCount
                        return
                    }
                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', 'Não foi possível carregar as respostas.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Abre o dialog com as informações da resposta
             */
            async dialogResponse (index, row, event) {
                this.dialog.visible = true
                this.dialog.data = row
                this.dialog.form.msgReponse_Id = row.id
                await this.contact(row.phone)
                await this.message(row.ident_sms)
            },

            /**
             * Envia uma resposta para a resposta
             */
            async saveForm () {
                try {
                    this.$eventHub.$emit('loading', true, 'Enviando uma resposta.')
                    let result = await ResponsesServices.store({
                        msgReponse_Id: this.dialog.form.msgReponse_Id,
                        message: this.dialog.form.message
                    })
                    if (result && result.status) {
                        this.checkMessageResponse(this.dialog.form.msgReponse_Id)
                        this.dialog.form = {
                            message: '',
                            msgReponse_Id: 0
                        }
                        this.dialog.visible = false
                        this.$eventHub.$emit('snackbar', 'success', 'A resposta foi enviada com sucesso.')
                        return
                    }
                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', 'Não foi possível enviar a resposta.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Marcando a mensagem que foi respondida com { isReplied = true }
             */
            checkMessageResponse (messageId) {
                this.responses.list = this.responses.list.map((item) => {
                    if (item.id === messageId) {
                        item.isReplied = true
                    }
                    return item
                })
            },

            /**
             * Formata a mensagem removendo caracteres especiais, etc...
             */
            messageSlug () {
                this.dialog.form.message = this.strSlug(this.dialog.form.message)
            },

            async blackList (id, blacklist) {
                try {
                    this.$eventHub.$emit('loading', true, 'Atualizando lista contatos bloqueados.')
                    let result = await ResponsesServices.blacklist({ id, blacklist })
                    if (result && result.status) {
                        this.$eventHub.$emit('snackbar', 'success', 'A lista contatos bloqueados foi atualizada com sucesso.')
                        return
                    }
                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', 'Não foi possível atualizar a lista de contatos bloqueados.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            async blackListNew (phone) {
                try {
                    this.$eventHub.$emit('loading', true, 'Aguarde... Adicionando o número a lista de contatos bloqueados.')

                    let result = await BlacklistServices.single({
                        phone: this.dialog.data.phone,
                        optional: ''
                    })

                    if (result && result.status) {
                        this.contact(this.dialog.data.phone)
                        return
                    } else if (result.code === 422) {
                        for (const key in result.results.errors) {
                            if (result.results.errors.hasOwnProperty(key)) {
                                const element = result.results.errors[key]
                                this.$eventHub.$emit('snackbar', 'error', element.message, false)
                                return
                            }
                        }
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível salvar na lista de contatos bloqueados.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            async contact (phone) {
                try {
                    this.dialog.contact.loading = true
                    let result = await ResponsesServices.contact({ phone })
                    if (result && result.status) {
                        this.dialog.contact.data = result.results
                        return
                    }
                    throw Error(result.message)
                } catch (e) {
                    this.dialog.contact.loading = false
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            async message (id) {
                try {
                    this.$eventHub.$emit('loading', true, 'Carregando dados da mensagem enviada.')
                    let result = await ResponsesServices.message({ id })
                    if (result && result.status) {
                        console.log(result.results.message)
                        this.dialog.data.campaign.message = result.results.message
                        return
                    }
                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar a mensagem.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            }
        }

    }
</script>

<style lang="stylus" scoped>

    @import './../../../../assets/stylus/bootstrap.styl'

    .mu-dialog

        .dialog-response

            .campaign
                margin 0 0 15px 0

                label
                    font-size 12px
                p
                    margin 0

            .phone
                font-size 14px
                font-weight bold
                line-height 40px
                margin-bottom 8px
                svg
                    margin-right 10px

            .date
                font-size 12px
                color #999

            .status
                margin-bottom 20px
                &.answered
                    color $green
                &.not-answered
                    color $red

            .message
                margin-bottom 8px
                color $primary

            .blacklist
                margin-top 15px
                background #f5f5f5
                border 1px #333 solid
                padding 10px
                .mu-switch
                    margin-left 10px
                p
                    margin 0
                strong
                    span
                        color #000
                        text-decoration underline

    .responses

        .paginate
            padding 20px

        td
            cursor pointer
            .status
                &.answered
                    color $green
                &.not-answered
                    color $red

</style>
